export default {
	searchParams: SEARCH_PARAMS(),
	carSaleList: [],
	pagingInfo: PAGING_INFO()
};

function SEARCH_PARAMS() {
	return {
		pmcId: '',
		pmcIdInput: '',
		cmpnNo: ''
	};
}

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 1
	};
}

export { SEARCH_PARAMS, PAGING_INFO };
